// Self-hosted Geist webfont for Malachite — the body typeface of the new type system.
//
// Same constraint as Inter (see inter-font.ts): Malachite renders inside a shadow root and
// @font-face rules don't load fonts from inside a shadow root, so the declarations are
// injected into document.head once, the first time a Malachite context mounts. The
// --font-body theme token (see tailwind.css) then resolves to it.
import geistLatin400 from '@fontsource/geist-sans/files/geist-sans-latin-400-normal.woff2';
import geistLatin500 from '@fontsource/geist-sans/files/geist-sans-latin-500-normal.woff2';

const LATIN_RANGE =
    'U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD';

const FACES: ReadonlyArray<{ weight: number; src: string; range: string }> = [
    { weight: 400, src: geistLatin400, range: LATIN_RANGE },
    { weight: 500, src: geistLatin500, range: LATIN_RANGE },
];

const STYLE_ID = 'malachite-geist-font-face';

let injected = false;

export const ensureGeistFontFace = (): void => {
    if (injected || typeof document === 'undefined' || !document.head) {
        return;
    }
    if (document.getElementById(STYLE_ID)) {
        injected = true;
        return;
    }
    const css = FACES.map(
        ({ weight, src, range }) =>
            `@font-face{font-family:'Geist';font-style:normal;font-weight:${weight};font-display:swap;src:url('${src}') format('woff2');unicode-range:${range};}`,
    ).join('');
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
    injected = true;
};
